module.exports = __webpack_public_path__ + "static/media/support.9df95f1e.png";